// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"d6ea55c1","453":"b8e87103"}[chunkId] + ".chunk.js";
};